import React from 'react'
import FlexView from 'react-flexview/lib'
import { LiabilityCoveragePopover } from '../../Core/Popover/LiabilityCoveragePopover'
import { RadioGroup, FormControlLabel,FormHelperText, Radio, MenuItem, Select, TextField } from '@material-ui/core'
import { FirebaseService, FirebaseConfigKey } from '../../../services/FirebaseService'
import { liabilityLimitPretty,isCanada } from '../../../services/utils'
import { InsurancePurchaseContextStore } from '../../../context/InsuracePurchaseContext'
import { EventEmitterService, EventKey } from '../../../services/EventEmitterService'
import { SessionContextStore } from '../../../context/SessionContext'
import { BuyingInsuranceContextStore } from '../../../context/BuyingInsuranceContext'
import { useLocation } from 'react-router-dom'
import './CustomizeLiabilitySection.scss'
import { BrowserView, MobileView } from "react-device-detect"
import { NUMBER_OF_DRONES_QUESTION_ANSWERS, SKYWATCH_GLOBAL_PORTAL_URL } from "../../../Constants";
import { useForm } from 'react-hook-form'
import { UserProfileContextStore ,ACTIONS} from "../../../context/UserProfileContext"
import {ModificationContextStore} from '../../../context/ModificationContext'
import { Action } from '../../../models/Action';
import { SixDronesPlusPopover } from '../../PopUps/SixDronesPlusPopup/SixDronesPlusPopup';
import { NumberOfDronesPopover } from '../../Core/Popover/NumberOfDronesPopover'
import usePopUp from '../../../hooks/usePopUp'
var classNames = require('classnames')

const shouldRedirectToSite = process.env.REACT_APP_SHOULD_REDIRECT === 'true';


export const CustomizeNumberOfDronesSection = ({value,isModify=false,isRenewal, modificationObject}) => {
    const insuracePurchaseContext = React.useContext(InsurancePurchaseContextStore)
    const {handleClose, handleOpen, isOpen} = usePopUp();
    const sessionContext = React.useContext(SessionContextStore)
    const profileContext = React.useContext(UserProfileContextStore)
    const offersContext = React.useContext(BuyingInsuranceContextStore)
    const { register, triggerValidation, errors, getValues } = useForm({mode: 'onChange'})
    const modificationContext = React.useContext(ModificationContextStore) 

    React.useEffect(() => {
        if(!profileContext.number_of_drones_operate) return
        offersContext.changeNumberOfDronesUserOperate(profileContext.number_of_drones_operate)
    },[profileContext.number_of_drones_operate])

    const onChangeNumberOfDronesOperate = (selectedOption) => {
        if(selectedOption === '2') {
            handleOpen();
            return;
        }
        if(isModify){
            modificationContext.setNumberOfDronesOperate(Number(selectedOption),isRenewal)
        }
        else if(selectedOption != undefined){
            offersContext.changeNumberOfDronesUserOperate(Number(selectedOption))
            profileContext.dispatch(new Action(ACTIONS.CHANGE_NUMBER_OF_DRONES_OPERATE,Number(selectedOption)))
        }
    }

    return (
            <>
                <div>
                    {!isModify && <FlexView vAlignContent={'center'} className="text-body bold black">How Many Drones Do You Operate ?<NumberOfDronesPopover/></FlexView>}
                    <>
                        <BrowserView>
                            <RadioGroup
                            className="margin-top-small" 
                            value={NUMBER_OF_DRONES_QUESTION_ANSWERS[isModify ? modificationObject.numberOfDronesOperate: profileContext.number_of_drones_operate ]}
                            name ="number_of_drones_operate"
                            helperText={!!errors.number_of_drones_operate && 'Name is required'}
                            error={!!errors.number_of_drones_operate}>
                                <FlexView className="space-between">
                                    {Object.keys(NUMBER_OF_DRONES_QUESTION_ANSWERS).filter(option => (!(option === "2" && isModify))).map(option => 
                                                <FormControlLabel
                                                onChange={()=>onChangeNumberOfDronesOperate(option)}
                                                className={classNames("radio-number-of-drones",{"margin-left-10":(isModify)})} 
                                                key={option} 
                                                value={NUMBER_OF_DRONES_QUESTION_ANSWERS[option]} 
                                                control={<Radio disabled={isModify && !isRenewal} color="primary" />}
                                                label={
                                                <div 
                                                className={classNames("text-small", "number-of-drones-text",
                                                {"bold": (isModify && modificationObject.numberOfDronesOperate == option)})}>
                                                {NUMBER_OF_DRONES_QUESTION_ANSWERS[option]["value"]}</div>} />
                                    )}
                                </FlexView>
                            </RadioGroup>
                            {isModify && modificationObject && NUMBER_OF_DRONES_QUESTION_ANSWERS[!!modificationObject ? 0 : modificationObject.numberOfDronesOperate]['max_drones'] != 0 && modificationObject.drones.length > NUMBER_OF_DRONES_QUESTION_ANSWERS[modificationObject.numberOfDronesOperate]['max_drones'] && isModify && <div className='text-body red'>Drones selected cannot be fewer than those scheduled in the hull section</div>}
                            {NUMBER_OF_DRONES_QUESTION_ANSWERS[offersContext.numberOfDronesOperate]['max_drones'] != 0 && insuracePurchaseContext.drones.length > NUMBER_OF_DRONES_QUESTION_ANSWERS[offersContext.numberOfDronesOperate]['max_drones'] && !isModify && <FormHelperText error>Drones selected cannot be fewer than those scheduled in the hull section</FormHelperText>}
                        </BrowserView>

                        <MobileView>
                            <TextField select size="small" InputProps={{ disableUnderline: true, className: 'lightgrayblue'}} className="margin-top-basic" variant="outlined" fullWidth 
                            onChange={(e)=>onChangeNumberOfDronesOperate(e.target.value)} 
                            value = {isModify? modificationObject.numberOfDronesOperate : offersContext.numberOfDronesOperate}>                                    
                            {Object.keys(NUMBER_OF_DRONES_QUESTION_ANSWERS).filter(option => (!(option === "2" && isModify))).map(option => 
                                        <MenuItem
                                        disabled={isModify && !isRenewal}
                                        className={classNames("text-small", "radio-liability",
                                        {"bold": (isModify && modificationObject.numberOfDronesOperate == option)})}
                                        key={option} 
                                        value={option} 
                                        >
                                            {NUMBER_OF_DRONES_QUESTION_ANSWERS[option]["value"]}
                                        </MenuItem>
                                    )}
                            </TextField>
                            {isModify && modificationObject && NUMBER_OF_DRONES_QUESTION_ANSWERS[!!modificationObject ? 0 : modificationObject.numberOfDronesOperate]['max_drones'] != 0 && modificationObject.drones.length > NUMBER_OF_DRONES_QUESTION_ANSWERS[modificationObject.numberOfDronesOperate]['max_drones'] && isModify && <div className='text-body red'>Drones selected cannot be fewer than those scheduled in the hull section</div>}
                            {NUMBER_OF_DRONES_QUESTION_ANSWERS[offersContext.numberOfDronesOperate]['max_drones'] != 0 &&insuracePurchaseContext.drones.length > NUMBER_OF_DRONES_QUESTION_ANSWERS[offersContext.numberOfDronesOperate]['max_drones'] && <FormHelperText error>Drones selected cannot be fewer than those scheduled in the hull section</FormHelperText>}
                        </MobileView>
                    </>
                </div>
            <SixDronesPlusPopover 
                handleClose={handleClose} 
                handleOpen={handleOpen} 
                isOpen={isOpen} 
                handleAgree={() => {
                    window.open('/insurance/fleet', '_blank', 'noreferrer');
                }} />
        </>
    )
}